import UsersApi from '@/frontend/api/user';
import { ElMessage, ElLoading } from 'element-plus';
import handlerErrorRequest from '@/frontend/functions/handlerErrorRequest';
export default {
  name: "NewPasswordPage",

  data() {
    return {
      form: {},
      passwordTwo: '',
      hiddenPassword: true,
      hiddenPasswordTwo: true
    };
  },

  methods: {
    handlerSubmit() {
      let loader = ElLoading.service({
        lock: false,
        text: 'Загрузка'
      });

      if (!this.form.password) {
        ElMessage.warning('Введите пароль');
        loader.close();
        return;
      }

      if (this.form.password !== this.passwordTwo) {
        ElMessage.warning('Пароли не совпадают');
        loader.close();
        return;
      }

      UsersApi.resetPassword(this.form, this.$route.params.hash).then(response => {
        if (!response.success) {
          ElMessage.error(response.message);
          return;
        }

        ElMessage({
          type: 'success',
          message: response.message
        });
        this.$router.push({
          name: 'sign-in'
        });
      }).catch(handlerErrorRequest).finally(() => loader.close());
    }

  },
  computed: {
    passwordType() {
      return this.hiddenPassword ? 'password' : 'text';
    },

    passwordTwoType() {
      return this.hiddenPasswordTwo ? 'password' : 'text';
    }

  },

  beforeCreate() {
    let loader = ElLoading.service({
      lock: false,
      text: 'Загрузка'
    });
    UsersApi.validateToken(this.$route.params.hash).then(response => {
      if (response.success) return;
      ElMessage.error(response.message);
      this.$router.replace({
        name: 'main'
      });
    }).catch(handlerErrorRequest).finally(() => loader.close());
  }

};